import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAppStore } from '../stores/useAppStore'

const XeroPaymentSuccess = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { addNotification } = useAppStore()

  useEffect(() => {
    const sessionId = searchParams.get('session_id')
    
    if (sessionId) {
      // Mark payment as successful for the component to pick up
      sessionStorage.setItem('xeroPaymentSuccessCallback', 'true')
      
      addNotification({
        type: 'success',
        message: 'Your invoice was successfully paid!',
        timestamp: Date.now()
      })
    }
  }, [searchParams, addNotification])

  const handleReturnToWorkOrder = () => {
    const recID = searchParams.get('recID')
    
    if (recID) {
      // Navigate to the specific work order details
      navigate(`/workorder/${recID}`)
    } else {
      // Fallback to work orders list
      navigate('/workorders')
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <div className="text-6xl mb-4">✅</div>
          <h1 className="text-2xl font-bold text-green-600 mb-2">Success!</h1>
          <p className="text-gray-600 mb-4">
            Your invoice was successfully paid.
          </p>
        </div>

        <div className="mb-6">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-center justify-center">
              <div className="text-green-600 mr-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="text-green-800 font-medium">Payment Processed Successfully</span>
            </div>
          </div>
        </div>

        <button
          onClick={handleReturnToWorkOrder}
          className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg w-full transition-colors duration-200"
        >
          Return to Work Order
        </button>
      </div>
    </div>
  )
}

export default XeroPaymentSuccess 